import BlProductImageAv from './BlProductImageAv.vue'

BlProductImageAv.install = function(Vue) {
  Vue.component(BlProductImageAv.name, BlProductImageAv)
}

export default BlProductImageAv
